<template>

    <div ref="container" class="position-relative d-flex flex-column h-100">
		<loading ref="loading"></loading>
        <template v-if='survey'>
            <header class="list-header" style="z-index: 100;">
                <h1 class="h2 p-2 text-center">Form: <template v-if='form_submission && form_submission.form_version'>{{ form_submission.form_version.title }}</template></h1>
                <div v-if='isProxy()' class='banner-request-details-nobg' v-text="getCareeName()"></div>
            </header>

            

            <div class='scroller flex-grow-1-scroll h-100' ref="editScroller">
                <div class='p-2'>
                    <local-error v-bind:errors='errors' v-bind:inline='inline_errors'></local-error>
                    <div class='container w-100' v-show="signpost_items_visible">
                        <div class="card-button w-100 mb-2 p-3" v-if="keyword_question && keywords">
                            <div class="form-group w-100">
                                <label class="mb-3">{{ keyword_question.title }}</label>
                            
                                <input type="text" disabled readonly class="form-control w-100" v-model="keywords">
                            </div>
                        </div>
                        <h3 class="pt-3 pb-3">{{ $t('translations.signpost_title') }}</h3>
                        <custom-action-selector                 
                            v-model="signpost_submission_id"
                            init_type='patient' 
                            :custom_actions="$root.provider.custom_action"
                            :user_id="form_submission.user_id" 
                            ref="custom_action_selector">
                        </custom-action-selector>
                        <h3 class="pt-3 pb-3">{{ $t('translations.signpost_continue_existing') }}</h3>
                    </div>

                    <div v-show='!signpost_items_visible'>
                        <p class="mt-2" v-if='!formAvailable()'>
                            <span class="icon-appointment mt-4 mb-3">
                                <svg x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><path id="Shape" 
                                        d="M18,12c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S14.7,12,18,12z M18,13.5c-2.5,0-4.5,2-4.5,4.5
                        s2,4.5,4.5,4.5s4.5-2,4.5-4.5S20.5,13.5,18,13.5z M15,0c0.5,0,0.9,0.4,1,0.9L16,1v1h2c1.6,0,2.9,1.2,3,2.8L21,5v4
                        c0,0.5-0.4,0.9-0.9,1L20,10H3v9c0,0.5,0.4,0.9,0.9,1L4,20h6c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1L10,22H4c-1.6,0-2.9-1.2-3-2.8
                        L1,19V5c0-1.6,1.2-2.9,2.8-3L4,2h2V1c0-0.6,0.4-1,1-1c0.5,0,0.9,0.4,1,0.9L8,1v1h6V1C14,0.4,14.4,0,15,0z M18,14.2
                        c0.4,0,0.7,0.3,0.7,0.6l0,0.1v2.6l1.7,1.3c0.3,0.2,0.4,0.6,0.2,1L20.6,20c-0.2,0.3-0.6,0.4-1,0.2l-0.1-0.1l-2-1.5
                        c-0.2-0.1-0.3-0.3-0.3-0.5l0-0.1v-3C17.2,14.6,17.6,14.2,18,14.2z M6,4H4C3.5,4,3.1,4.4,3,4.9L3,5v3h16V5c0-0.5-0.4-0.9-0.9-1L18,4
                        h-2v1c0,0.5-0.4,0.9-0.9,1L15,6c-0.5,0-0.9-0.4-1-0.9L14,5V4H8v1c0,0.5-0.4,0.9-0.9,1L7,6C6.5,6,6.1,5.6,6,5.1L6,5V4z"/></g></svg>
                            </span>
                            <template v-if='$root.provider.network_service_status == 0'>
                                {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
                            </template>
                            <template v-else>
                                <div>{{ serviceAvailabliltyMessage() }}</div>
                                <div v-if='this.$root.encryptStorage'>{{autobrand('translations.session_saved_for_later')}}</div>
                            </template>
                        </p>
                        <survey v-else-if='survey' :survey='survey' />
                    </div>
                </div>
            </div>
            
            <footer class='list-footer open p-2'>
                <div v-if='!formAvailable()'>
                    <!-- Nothing to say here yet? -->
                </div>
                <span v-else-if="survey" id="surveyProgress">
					<button v-if="survey.mode != 'display'" v-show="survey.isLastPage" class='btn btn-success btn-round' :key="`complete_button_${complete_button_key}`" v-on:click.once="completeLastPageWrapper()">{{$t('translations.complete')}}</button>
                    <button v-else v-show="survey.isLastPage" class='btn btn-outline-primary btn-round btn-close' v-on:click="closeSurvey();">{{$t('translations.close')}}</button>

                    <template v-if='survey.visiblePageCount > 1'>
                        <button v-if="!survey.isLastPage" class='btn btn-success btn-round btn-next' v-on:click="nextPage()">{{$t('translations.next')}}</button>
						<button v-if="!tBrandSetting('conf_show_global_previous') && !survey.isFirstPage" class='btn btn-outline-primary btn-round btn-prev' v-on:click="goBack()">{{$t('translations.prev')}}</button>
                    </template>
                    
                    <button v-show="survey.mode != 'display'" class='btn btn-outline-primary btn-round btn-save' v-on:click="saveProgress()">{{$t('translations.save_qa')}}</button>
                    <button v-show="survey.mode != 'display'" class='btn btn-warning btn-round float-right btn-cancel' v-on:click="cancel()">{{$t('translations.cancel')}}</button>
                </span>
            </footer>
        </template>
	</div>
</template>

<script>
//import * as SurveyVue from 'survey-vue';
export default {
    extends: app.base.formSubmissionBase,
    data: function() {
        return {
            signpost_enabled: true,
        };
    },
    methods: {
        formAvailable() {
            // if we have a message attached, we are already in an existing thread so
            // we allow the user to continue filling in the form.
            if(this.form_submission.message_id) {
                console.log("formAvailable: Allowing existing thread");
                return true;
            }
            // We ALWAYS allow campaign submissions 
            if(this.form_submission.campaign_id) {
                console.log("formAvailable: Allowing campaign");
                return true;
            } 
            // Otherwise the service has to be available to be able to submit
            // a new form, and the custom action has to be available.
            if(this.form_submission.custom_action) {
                var custom_action = this.$root.provider.custom_action.find(obj => obj.id == this.form_submission.custom_action.id);
                console.log("formAvailable: Custom action", custom_action);
                
                return (
                    custom_action.available 
                    && this.$root.provider.calc_service_status != this.$root.lookup.service_status.OFFLINE
                ); 
            } 
            // Otherwise the service has to just be available.
            // @note There is no case for this yet, but it is a nice fallback for now.
            console.log("formAvailable: Fallback");
            return isServiceAvailable(); 
        },
        checkRouteChange(to, from, next) {
            if(!this.formAvailable()) {
                next();
            }
            else {
                this.checkUnsaved(this.originalData, this.survey.data, to, from, next);
            }
        },
        isProxy() {
            var id_object;
            if(this.form_submission.message) {
                id_object = this.form_submission.message.thread;
            }
            else{
                id_object = this.form_submission;
            }
            return id_object && id_object.user_id != this.$root.user.id;
        },

        getCareeName() {
            var id_object;
            if(this.form_submission.message) {
                id_object = this.form_submission.message.thread;
            }
            else{
                id_object = this.form_submission;
            }
            if(id_object && id_object.user_id != this.$root.user.id) {
                var caree = this.getCaree(id_object.user_id);
                if(caree) {
                    return caree.forenames + " " + caree.surname + " " + this.formatDate(caree.dob);
                }
                else {
                    this.$router.push({name: "Profile"});
                }
            }
        }
    }
}
</script>
